<template>
  <div
      v-bind="$attrs"
      :class="['innerClass flex overflow-x-scroll gap-4', wrapperClasses]"
      :style="{ height: props.height, width: props.width }"
      :data-testid="props.dataTestid"
  >
    <slot/>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, defineProps, defineOptions } from 'vue'

type Props = {
  height?: string;
  width?: string;
  scrollbar?: boolean;
  dataTestid?: string;
}

const props = withDefaults(defineProps<Props>(), {
  height: '',
  scrollbar: false,
  dataTestid: 'molecule-XscrollContainer'
});

defineOptions({
  inheritAttrs: false,
});

const wrapperClasses = {
  'scrollbar': props.scrollbar,
};
</script>
